import { Link } from "react-router-dom";

import type { PipelineRun } from "../lib/api";
import { formatDateTime, formatTokens } from "../lib/format";
import { DeliveryStatusBadge, StatusBadge } from "./status-badge";

const deliveryLabels: Record<
  NonNullable<PipelineRun["deliveryStatus"]>,
  string
> = {
  NOT_STARTED: "Отправка не начиналась",
  PENDING: "Ответ подготовлен",
  ACCEPTED: "Принято Wazzup",
  SENT: "Отправлено каналом",
  DELIVERED: "Доставлено",
  READ: "Прочитано",
  UNKNOWN: "Результат неизвестен",
  FAILED: "Ошибка доставки",
};

export function RunList({ runs }: { runs: PipelineRun[] }) {
  if (runs.length === 0) {
    return (
      <div className="panel p-4 text-sm text-muted-foreground">
        Запусков не найдено.
      </div>
    );
  }
  return (
    <div className="space-y-3">
      {runs.map((run) => (
        <Link
          key={run.id}
          className="panel block p-4 transition-colors hover:border-primary/40 hover:bg-accent/40"
          to={`/runs/${run.id}`}
        >
          <div className="flex flex-wrap items-center gap-2">
            <StatusBadge status={run.status} />
            <span className="text-xs text-muted-foreground">
              {formatDateTime(run.createdAt)}
            </span>
            {run.resultDisplay && <span className="rounded-md border px-2 py-1 text-xs font-medium">{run.resultDisplay.label}</span>}
            <DeliveryStatusBadge
              status={run.deliveryStatus ?? "NOT_STARTED"}
              label={
                run.deliveryDisplay?.label ??
                deliveryLabels[run.deliveryStatus ?? "NOT_STARTED"]
              }
            />
            {run.llmUsage.totalTokens > 0 ? (
              <span className="text-xs text-muted-foreground">
                {formatTokens(run.llmUsage.totalTokens)} ток.
              </span>
            ) : null}
          </div>
          <p className="mt-2 truncate text-sm font-medium">
            {(run.inboundPreview ?? run.inboundText.slice(0, 200)) ||
              "Без текстового сообщения"}
          </p>
          <p className="mt-1 text-xs text-muted-foreground">
            {run.funnel?.name ?? "Маршрут не определён"}
            {run.amoLeadId ? ` · lead ${run.amoLeadId}` : ""}
            {run.senderPhone ? ` · ${run.senderPhone}` : ""}
            {` · событий ${run.eventsCount ?? 0}`}
          </p>
        </Link>
      ))}
    </div>
  );
}
